import { render, staticRenderFns } from "./SortTypeDialog.vue?vue&type=template&id=6dd3f160&scoped=true&"
import script from "./SortTypeDialog.vue?vue&type=script&lang=js&"
export * from "./SortTypeDialog.vue?vue&type=script&lang=js&"
import style0 from "./SortTypeDialog.vue?vue&type=style&index=0&id=6dd3f160&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd3f160",
  null
  
)

export default component.exports